<template>
  <div class="box_title">
    <h1>La table de Pythagore</h1>
  </div>
  <div class="container">

    <button @click="shuffleAll" class="btn" type="button" name="button">Ranger</button>

    <button @click="change_mode" class="btn" type="button" name="button">Mode : {{ this.mode.name }}</button>

    <div id="tapis" class="tapis">
      <!-- Carpet  -->
      <img src='../../assets/images/fonds/fond-pythagore.png' id="img_tapis" class="img_tapis" draggable="false"
      @mousemove.left="onMouseMove"
      @touchmove="onMouseMove"
      >
      <!-- Elements  -->
      <img v-for="index in 100"  :key="index" :id="'poly_' + [index]" class="poly_1"
      @click="onMouseMove;rotateElement($event);"
      @mousemove.left="onMouseMove"
      @touchmove="onMouseMove"
      @mouseup.left="onUp"
      @mousedown.left="onDown"
      draggable="false"
      :src="require('../../assets/images/table-de-pythagore/' + this['poly_' + index].link + '.png')"
      :style="{ left: this['poly_' + index].pos_x * this.tapis.width + 'px', top: this['poly_' + index].pos_y * this.tapis.height + 'px' }">
    </div>
  </div>
</template>

<script>
export default {
  name: 'TablePythagore',
  mounted() {

    const io = new ResizeObserver(entries => {
      entries.forEach(entry => {
        this.getTapisPosition()
      })
    })
    const tapis_element = document.getElementById('tapis');
    io.observe(tapis_element);

    window.addEventListener('load', () => {
      setTimeout( () => this.initPositions(), 300);
    })

  },
  data() {
    return {
      mode : {
        value : 'move',
        name : 'Souris',
        bool : null,
        element_id : null
      },
      tapis : {
        top    : 0,
        right  : 0,
        bottom : 0,
        left   : 0,
        height : 0,
        width  : 0,
      },
      mouse_position : {
        pos_x : 0,
        pos_y : 0
      },
      square_sizes : {
        poly_1  : 0,
        poly_2  : 0,
        poly_3  : 0,
        poly_4  : 0,
        poly_5  : 0,
        poly_6  : 0,
        poly_7  : 0,
        poly_8  : 0,
        poly_9  : 0,
        poly_10 : 0,
      },
      poly_1: {
        link : 'poly_1',
        pos_x: 0,
        pos_y: 0
      },
      poly_2: {
        link : 'poly_2',
        pos_x: 0,
        pos_y: 0
      },
      poly_3: {
        link : 'poly_3',
        pos_x: 0,
        pos_y: 0
      },
      poly_4: {
        link : 'poly_4',
        pos_x: 0,
        pos_y: 0
      },
      poly_5: {
        link : 'poly_5',
        pos_x: 0,
        pos_y: 0
      },
      poly_6: {
        link : 'poly_6',
        pos_x: 0,
        pos_y: 0
      },
      poly_7: {
        link : 'poly_7',
        pos_x: 0,
        pos_y: 0
      },

      poly_8: {
        link : 'poly_8',
        pos_x: 0,
        pos_y: 0
      },
      poly_9: {
        link : 'poly_9',
        pos_x: 0,
        pos_y: 0
      },
      poly_10: {
        link : 'poly_10',
        pos_x: 0,
        pos_y: 0
      },
      poly_11: {
        link : 'poly_11',
        pos_x: 0,
        pos_y: 0
      },
      poly_12: {
        link : 'poly_12',
        pos_x: 0,
        pos_y: 0
      },
      poly_13: {
        link : 'poly_13',
        pos_x: 0,
        pos_y: 0
      },
      poly_14: {
        link : 'poly_14',
        pos_x: 0,
        pos_y: 0
      },
      poly_15: {
        link : 'poly_15',
        pos_x: 0,
        pos_y: 0
      },
      poly_16: {
        link : 'poly_16',
        pos_x: 0,
        pos_y: 0
      },
      poly_17: {
        link : 'poly_17',
        pos_x: 0,
        pos_y: 0
      },

      poly_18: {
        link : 'poly_18',
        pos_x: 0,
        pos_y: 0
      },
      poly_19: {
        link : 'poly_19',
        pos_x: 0,
        pos_y: 0
      },
      poly_20: {
        link : 'poly_20',
        pos_x: 0,
        pos_y: 0
      },
      poly_21: {
        link : 'poly_21',
        pos_x: 0,
        pos_y: 0
      },
      poly_22: {
        link : 'poly_22',
        pos_x: 0,
        pos_y: 0
      },
      poly_23: {
        link : 'poly_23',
        pos_x: 0,
        pos_y: 0
      },
      poly_24: {
        link : 'poly_24',
        pos_x: 0,
        pos_y: 0
      },
      poly_25: {
        link : 'poly_25',
        pos_x: 0,
        pos_y: 0
      },
      poly_26: {
        link : 'poly_26',
        pos_x: 0,
        pos_y: 0
      },
      poly_27: {
        link : 'poly_27',
        pos_x: 0,
        pos_y: 0
      },

      poly_28: {
        link : 'poly_28',
        pos_x: 0,
        pos_y: 0
      },
      poly_29: {
        link : 'poly_29',
        pos_x: 0,
        pos_y: 0
      },
      poly_30: {
        link : 'poly_30',
        pos_x: 0,
        pos_y: 0
      },
      poly_31: {
        link : 'poly_31',
        pos_x: 0,
        pos_y: 0
      },
      poly_32: {
        link : 'poly_32',
        pos_x: 0,
        pos_y: 0
      },
      poly_33: {
        link : 'poly_33',
        pos_x: 0,
        pos_y: 0
      },
      poly_34: {
        link : 'poly_34',
        pos_x: 0,
        pos_y: 0
      },
      poly_35: {
        link : 'poly_35',
        pos_x: 0,
        pos_y: 0
      },
      poly_36: {
        link : 'poly_36',
        pos_x: 0,
        pos_y: 0
      },
      poly_37: {
        link : 'poly_37',
        pos_x: 0,
        pos_y: 0
      },

      poly_38: {
        link : 'poly_38',
        pos_x: 0,
        pos_y: 0
      },
      poly_39: {
        link : 'poly_39',
        pos_x: 0,
        pos_y: 0
      },
      poly_40: {
        link : 'poly_40',
        pos_x: 0,
        pos_y: 0
      },
      poly_41: {
        link : 'poly_41',
        pos_x: 0,
        pos_y: 0
      },
      poly_42: {
        link : 'poly_42',
        pos_x: 0,
        pos_y: 0
      },
      poly_43: {
        link : 'poly_43',
        pos_x: 0,
        pos_y: 0
      },
      poly_44: {
        link : 'poly_44',
        pos_x: 0,
        pos_y: 0
      },
      poly_45: {
        link : 'poly_45',
        pos_x: 0,
        pos_y: 0
      },
      poly_46: {
        link : 'poly_46',
        pos_x: 0,
        pos_y: 0
      },
      poly_47: {
        link : 'poly_47',
        pos_x: 0,
        pos_y: 0
      },

      poly_48: {
        link : 'poly_48',
        pos_x: 0,
        pos_y: 0
      },
      poly_49: {
        link : 'poly_49',
        pos_x: 0,
        pos_y: 0
      },
      poly_50: {
        link : 'poly_50',
        pos_x: 0,
        pos_y: 0
      },
      poly_51: {
        link : 'poly_51',
        pos_x: 0,
        pos_y: 0
      },
      poly_52: {
        link : 'poly_52',
        pos_x: 0,
        pos_y: 0
      },
      poly_53: {
        link : 'poly_53',
        pos_x: 0,
        pos_y: 0
      },
      poly_54: {
        link : 'poly_54',
        pos_x: 0,
        pos_y: 0
      },
      poly_55: {
        link : 'poly_55',
        pos_x: 0,
        pos_y: 0
      },
      poly_56: {
        link : 'poly_56',
        pos_x: 0,
        pos_y: 0
      },
      poly_57: {
        link : 'poly_57',
        pos_x: 0,
        pos_y: 0
      },

      poly_58: {
        link : 'poly_58',
        pos_x: 0,
        pos_y: 0
      },
      poly_59: {
        link : 'poly_59',
        pos_x: 0,
        pos_y: 0
      },
      poly_60: {
        link : 'poly_60',
        pos_x: 0,
        pos_y: 0
      },
      poly_61: {
        link : 'poly_61',
        pos_x: 0,
        pos_y: 0
      },
      poly_62: {
        link : 'poly_62',
        pos_x: 0,
        pos_y: 0
      },
      poly_63: {
        link : 'poly_63',
        pos_x: 0,
        pos_y: 0
      },
      poly_64: {
        link : 'poly_64',
        pos_x: 0,
        pos_y: 0
      },
      poly_65: {
        link : 'poly_65',
        pos_x: 0,
        pos_y: 0
      },
      poly_66: {
        link : 'poly_66',
        pos_x: 0,
        pos_y: 0
      },
      poly_67: {
        link : 'poly_67',
        pos_x: 0,
        pos_y: 0
      },

      poly_68: {
        link : 'poly_68',
        pos_x: 0,
        pos_y: 0
      },
      poly_69: {
        link : 'poly_69',
        pos_x: 0,
        pos_y: 0
      },
      poly_70: {
        link : 'poly_70',
        pos_x: 0,
        pos_y: 0
      },
      poly_71: {
        link : 'poly_71',
        pos_x: 0,
        pos_y: 0
      },
      poly_72: {
        link : 'poly_72',
        pos_x: 0,
        pos_y: 0
      },
      poly_73: {
        link : 'poly_73',
        pos_x: 0,
        pos_y: 0
      },
      poly_74: {
        link : 'poly_74',
        pos_x: 0,
        pos_y: 0
      },
      poly_75: {
        link : 'poly_75',
        pos_x: 0,
        pos_y: 0
      },
      poly_76: {
        link : 'poly_76',
        pos_x: 0,
        pos_y: 0
      },
      poly_77: {
        link : 'poly_77',
        pos_x: 0,
        pos_y: 0
      },

      poly_78: {
        link : 'poly_78',
        pos_x: 0,
        pos_y: 0
      },
      poly_79: {
        link : 'poly_79',
        pos_x: 0,
        pos_y: 0
      },
      poly_80: {
        link : 'poly_80',
        pos_x: 0,
        pos_y: 0
      },
      poly_81: {
        link : 'poly_81',
        pos_x: 0,
        pos_y: 0
      },
      poly_82: {
        link : 'poly_82',
        pos_x: 0,
        pos_y: 0
      },
      poly_83: {
        link : 'poly_83',
        pos_x: 0,
        pos_y: 0
      },
      poly_84: {
        link : 'poly_84',
        pos_x: 0,
        pos_y: 0
      },
      poly_85: {
        link : 'poly_85',
        pos_x: 0,
        pos_y: 0
      },
      poly_86: {
        link : 'poly_86',
        pos_x: 0,
        pos_y: 0
      },
      poly_87: {
        link : 'poly_87',
        pos_x: 0,
        pos_y: 0
      },

      poly_88: {
        link : 'poly_88',
        pos_x: 0,
        pos_y: 0
      },
      poly_89: {
        link : 'poly_89',
        pos_x: 0,
        pos_y: 0
      },
      poly_90: {
        link : 'poly_90',
        pos_x: 0,
        pos_y: 0
      },
      poly_91: {
        link : 'poly_91',
        pos_x: 0,
        pos_y: 0
      },
      poly_92: {
        link : 'poly_92',
        pos_x: 0,
        pos_y: 0
      },
      poly_93: {
        link : 'poly_93',
        pos_x: 0,
        pos_y: 0
      },
      poly_94: {
        link : 'poly_94',
        pos_x: 0,
        pos_y: 0
      },
      poly_95: {
        link : 'poly_95',
        pos_x: 0,
        pos_y: 0
      },
      poly_96: {
        link : 'poly_96',
        pos_x: 0,
        pos_y: 0
      },
      poly_97: {
        link : 'poly_97',
        pos_x: 0,
        pos_y: 0
      },

      poly_98: {
        link : 'poly_98',
        pos_x: 0,
        pos_y: 0
      },
      poly_99: {
        link : 'poly_99',
        pos_x: 0,
        pos_y: 0
      },
      poly_100: {
        link :  'poly_100',
        pos_x: 0,
        pos_y: 0
      },
      element : {
        clicked : null,
      },
      shuffle_values : {
        value : null,
      }
    }
  },
  methods: {
    change_mode(){
      var current_val = this.mode.value;
      this.mode.value = (current_val == 'move') ? 'rotation' : 'move';
      this.mode.name  = (current_val == 'move') ? 'Rotation' : 'Souris';
    },
    initPositions(){
      var k = 0;
      for (var j = 0; j < 90; j++) {

        if ( j % 10 == 0 ) {


          var arr = [1,2,3,4,5,6,7,8,9,10];

          var pos = [
            [0.135, 0.13],
            [1.09, 0.13],
            [2.023, 0.13],
            [0.428, 0.13],
            [1.38, 0.13],
            [2.325, 0.13],
            [0.730, 0.13],
            [1.67, 0.13],
            [2.620, 0.13]
          ];


          var lf = pos[k][0] * this.tapis.width/3;
          var raw = pos[k][1] * this.tapis.height/2;

          k = k+1;

          this['poly_' + (j + arr[0])].pos_x = this.percentX(lf);
          this['poly_' + (j + arr[0])].pos_y = this.percentY(raw);

          this['poly_' + (j + arr[1])].pos_x = this.percentX(lf);
          this['poly_' + (j + arr[1])].pos_y = this.percentY(raw);


          this['poly_' + (j + arr[2])].pos_x = this.percentX(lf);
          this['poly_' + (j + arr[2])].pos_y = this.percentY(raw);

          this['poly_' + (j + arr[3])].pos_x = this.percentX(lf);
          this['poly_' + (j + arr[3])].pos_y = this.percentY(raw);

          this['poly_' + (j + arr[4])].pos_x = this.percentX(lf);
          this['poly_' + (j + arr[4])].pos_y = this.percentY(raw);

          this['poly_' + (j + arr[5])].pos_x = this.percentX(lf);
          this['poly_' + (j + arr[5])].pos_y = this.percentY(raw);

          this['poly_' + (j + arr[6])].pos_x = this.percentX(lf);
          this['poly_' + (j + arr[6])].pos_y = this.percentY(raw);

          this['poly_' + (j + arr[7])].pos_x = this.percentX(lf);
          this['poly_' + (j + arr[7])].pos_y = this.percentY(raw);

          this['poly_' + (j + arr[8])].pos_x = this.percentX(lf);
          this['poly_' + (j + arr[8])].pos_y = this.percentY(raw);

          this['poly_' + (j + arr[9])].pos_x = this.percentX(lf);
          this['poly_' + (j + arr[9])].pos_y = this.percentY(raw);

          document.getElementById('poly_' + (j + arr[0])).style.zIndex = '110';
          document.getElementById('poly_' + (j + arr[1])).style.zIndex = '109';
          document.getElementById('poly_' + (j + arr[2])).style.zIndex = '108';
          document.getElementById('poly_' + (j + arr[3])).style.zIndex = '107';
          document.getElementById('poly_' + (j + arr[4])).style.zIndex = '106';
          document.getElementById('poly_' + (j + arr[5])).style.zIndex = '105';
          document.getElementById('poly_' + (j + arr[6])).style.zIndex = '104';
          document.getElementById('poly_' + (j + arr[7])).style.zIndex = '103';
          document.getElementById('poly_' + (j + arr[8])).style.zIndex = '102';
          document.getElementById('poly_' + (j + arr[9])).style.zIndex = '101';
        }
      }
    },
    getTapisPosition() {
      var tapis_element = document.getElementById('img_tapis');
      const rect        = tapis_element.getBoundingClientRect();
      this.tapis.top    = rect.top;
      this.tapis.right  = rect.right;
      this.tapis.left   = rect.left;
      this.tapis.width  = rect.width;
      this.tapis.bottom = rect.bottom;
      this.tapis.height = rect.height;

      var square = document.getElementById('poly_1');
      const carre       = square.getBoundingClientRect();

      this.square_sizes.poly_1  = 1 * square.width;
      this.square_sizes.poly_2  = 2 * square.width;
      this.square_sizes.poly_3  = 3 * square.width;
      this.square_sizes.poly_4  = 4 * square.width;
      this.square_sizes.poly_5  = 5 * square.width;
      this.square_sizes.poly_6  = 6 * square.width;
      this.square_sizes.poly_7  = 7 * square.width;
      this.square_sizes.poly_8  = 8 * square.width;
      this.square_sizes.poly_9  = 9 * square.width;
      this.square_sizes.poly_10 = 10 * square.width;

      console.log(this.square_sizes);

    },
    onDown(e) {
      if (this.mode.value === 'move') {
        var element    = e.currentTarget;
        this.element.clicked = element.id;
      }
    },
    moveAt() {
      var element_id = this.element.clicked;
      if (element_id && this.element.clicked !== null) {
        var element     = document.getElementById(element_id).getBoundingClientRect();
        this[element_id].pos_x = this.percentX(this.mouse_position.pox_x - this.tapis.left - (element.width/2));
        this[element_id].pos_y = this.percentY(this.mouse_position.pox_y - this.tapis.top - (element.height/2));

        if ((this[element_id].pos_x * this.tapis.width) < 0) {
          this[element_id].pos_x = 0 ;
        }
        if ((this[element_id].pos_y * this.tapis.height) < 0) {
          this[element_id].pos_y = 0 ;
        }

        if ((this[element_id].pos_x * this.tapis.width) + element.width  > this.tapis.width) {
          this[element_id].pos_x = this.percentX(this.tapis.width -  element.width);
        }

        if ((this[element_id].pos_y * this.tapis.height) + element.height > this.tapis.height) {
          this[element_id].pos_y = this.percentY(this.tapis.height - element.height);
        }
      }
    },
    onUp(e) {
      if (this.mode.value === 'move') {
        // e.preventDefault();
        var element    = e.currentTarget;
        var element_id = element.id;
        this[element_id].pos_x = this.percentX(this.mouse_position.pox_x - this.tapis.left - (element.offsetWidth/2));
        this[element_id].pos_y = this.percentY(this.mouse_position.pox_y - this.tapis.top - (element.offsetHeight/2));
        this.element.clicked = null;
      }

    },
    onMouseMove(e) {
      e.preventDefault();
        var evt = e.type === 'touchstart' ? e.changedTouches[0] : e;
        var element    = e.currentTarget;
        this.mouse_position.pox_x = evt.pageX;
        this.mouse_position.pox_y = evt.pageY;
        if (element !== 'undefined') {
          this.moveAt();
        }
    },
    percentX(x){
      return Math.round(1000 * x/this.tapis.width)/1000;
    },
    percentY(y){
      return Math.round(10000 * y/this.tapis.height)/10000;
    },
    shuffleAll(){
      this.shuffle_values.value = true;
      this.initPositions();

      setTimeout( () => {
        this.shuffle_values.value = null;
      }, 300);
    },
    shuffle(array) {
      let currentIndex = array.length,  randomIndex;

      // While there remain elements to shuffle.
      while (currentIndex != 0) {

        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex], array[currentIndex]];
        }

        return array;
      }
      ,
      rotateElement(e){
        if (this.mode.value !== 'move') {
          var element    = e.currentTarget;
          var element_id = element.id;
          this.mode.element_id = element_id;
          this.rotateElementLoop();
          this.mode.element_id = null;
        }
      },
      rotateElementLoop(){
        console.log('rotateElementLoop');
        var rotated;
        var div    = document.getElementById(this.mode.element_id);
        // var deg = rotated !== 'undefined' ? 0 : 66;
        var deg = 45;

        if (div.style.transform.match(/\d+/)) {
          deg = deg + parseInt(div.style.transform.match(/\d+/));
        }

        div.style.webkitTransform = 'rotate('+deg+'deg)';
        div.style.mozTransform    = 'rotate('+deg+'deg)';
        div.style.msTransform     = 'rotate('+deg+'deg)';
        div.style.oTransform      = 'rotate('+deg+'deg)';
        div.style.transform       = 'rotate('+deg+'deg)';

        rotated = !rotated;
        return this.mode.bool;
      }
    }
  }
  </script>
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .container{
    width: calc(100% - 40px);
    max-width: 1400px;
    margin-left: auto;
    margin-right: auto;
  }
  .tapis{
    display: block;
    position: relative;
    overflow: hidden;
  }
  .tapis img:first-child {
    margin: 0;
    width: 100%;
    height: auto;
    /* pointer-events: none; */
    user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
  .poly_1{
    display: block;
    /* width: 22.851%; */
    /* height: 20%; */
    /* width: auto; */
    height: auto;
    position: absolute;

    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */

   -webkit-transform: scale(1); /* Saf3.1+, Chrome */
    -moz-transform: scale(1); /* FF3.5+ */
     -ms-transform: scale(1); /* IE9 */
      -o-transform: scale(1); /* Opera 10.95+ */
         transform: scale(1);
            /* IE6–IE9 */
            filter: progid:DXImageTransform.Microsoft.Matrix(M11=0.9999619230641713, M12=-0.008726535498373935, M21=0.008726535498373935, M22=0.9999619230641713,SizingMethod='auto expand');
  }
  .btn {
    background-color: #4CAF50; /* Green */
    border: none;
    color: white;
    padding: 15px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    transition-duration: 0.4s;
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19);
    margin: 20px;
  }
  .btn:hover {
    background-color: white; /* Green */
    color: #000;
    border: solid 1px #4CAF50;
    box-shadow: 0 12px 16px 0 rgba(0,0,0,0.24), 0 17px 50px 0 rgba(0,0,0,0.19);
  }

  #poly_1{
  height: 1.4%;
  }
  #poly_2{
    height: 1.4%;
  }
  #poly_3{
    height: 1.4%;
  }
  #poly_4{
    height: 1.4%;
  }
  #poly_5{
    height: 1.4%;
  }
  #poly_6{
    height: 1.4%;
  }
  #poly_7{
    height: 1.4%;
  }
  #poly_8{
    height: 1.4%;
  }
  #poly_9{
    height: 1.4%;
  }
  #poly_10{
    height: 1.4%;
  }

  #poly_11{
    height: 1.4%;
  }
  #poly_12{
    height: 2.8%;
  }
  #poly_13{
    height: 2.8%;
  }
  #poly_14{
    height: 2.8%;
  }
  #poly_15{
    height: 2.8%;
  }
  #poly_16{
    height: 2.8%;
  }
  #poly_17{
    height: 2.8%;
  }
  #poly_18{
    height: 2.8%;
  }
  #poly_19{
    height: 2.8%;
  }
  #poly_20{
    height: 2.8%;
  }

  #poly_21{
    height: 1.4%;
  }
  #poly_22{
    height: 2.8%;
  }
  #poly_23{
    height: 4.2%;
  }
  #poly_24{
    height: 4.2%;
  }
  #poly_25{
    height: 4.2%;
  }
  #poly_26{
    height: 4.2%;
  }
  #poly_27{
    height: 4.2%;
  }
  #poly_28{
    height: 4.2%;
  }
  #poly_29{
    height: 4.2%;
  }
  #poly_30{
    height: 4.2%;
  }

  #poly_31{
    height: 1.4%;
  }
  #poly_32{
    height: 2.8%;
  }
  #poly_33{
    height: 4.2%;
  }
  #poly_34{
    height: 5.6%;
  }
  #poly_35{
    height: 5.6%;
  }
  #poly_36{
    height: 5.6%;
  }
  #poly_37{
    height: 5.6%;
  }
  #poly_38{
    height: 5.6%;
  }
  #poly_39{
    height: 5.6%;
  }
  #poly_40{
    height: 5.6%;
  }

  #poly_41{
    height: 1.4%;
  }
  #poly_42{
    height: 2.8%;
  }
  #poly_43{
    height: 5.6%;
  }
  #poly_44{
    height: 7%;
  }
  #poly_45{
    height: 7%;
  }
  #poly_46{
    height: 7%;
  }
  #poly_47{
    height: 7%;
  }
  #poly_48{
    height: 7%;
  }
  #poly_49{
    height: 7%;
  }
  #poly_50{
    height: 7%;
  }

  #poly_51{
    height: 1.4%;
  }
  #poly_52{
    height: 2.8%;
  }
  #poly_53{
    height: 5.6%;
  }
  #poly_54{
    height: 7%;
  }
  #poly_55{
    height: 8.4%;
  }
  #poly_56{
    height: 8.4%;
  }
  #poly_57{
    height: 8.4%;
  }
  #poly_58{
    height: 8.4%;
  }
  #poly_59{
    height: 8.4%;
  }
  #poly_60{
    height: 8.4%;
  }

  #poly_61{
    height: 1.4%;
  }
  #poly_62{
    height: 2.8%;
  }
  #poly_63{
    height: 5.6%;
  }
  #poly_64{
    height: 7%;
  }
  #poly_65{
    height: 8.4%;
  }
  #poly_66{
    height: 9.8%;
  }
  #poly_67{
    height: 9.8%;
  }
  #poly_68{
    height: 9.8%;
  }
  #poly_69{
    height: 9.8%;
  }
  #poly_70{
    height: 9.8%;
  }

  #poly_71{
    height: 1.4%;
  }
  #poly_72{
    height: 2.8%;
  }
  #poly_73{
    height: 5.6%;
  }
  #poly_74{
    height: 7%;
  }
  #poly_75{
    height: 8.4%;
  }
  #poly_76{
    height: 9.8%;
  }
  #poly_77{
    height: 9.8%;
  }
  #poly_78{
    height: 11.2%;
  }
  #poly_79{
    height: 11.2%;
  }
  #poly_80{
    height: 11.2%;
  }

  #poly_81{
    height: 1.4%;
  }
  #poly_82{
    height: 2.8%;
  }
  #poly_83{
    height: 5.6%;
  }
  #poly_84{
    height: 7%;
  }
  #poly_85{
    height: 8.4%;
  }
  #poly_86{
    height: 9.8%;
  }
  #poly_87{
    height: 9.8%;
  }
  #poly_88{
    height: 11.2%;
  }
  #poly_89{
    height: 12.6%;
  }
  #poly_90{
    height: 12.6%;
  }

  #poly_91{
    height: 1.4%;
  }
  #poly_92{
    height: 2.8%;
  }
  #poly_93{
    height: 4.2%;
  }
  #poly_94{
    height: 5.6%;
  }
  #poly_95{
    height: 7%;
  }
  #poly_96{
    height: 8.4%;
  }
  #poly_97{
    height: 9.8%;
  }
  #poly_98{
    height: 11.2%;
  }
  #poly_99{
    height: 12.6%;
  }
  #poly_100{
    height: 14%;
  }
  </style>
